import Layout from "../Layout/Layout.tsx";
import { JsonLDData } from "react-safe-json-ld";

const About = () => {
  const structuredData: JsonLDData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "AboutPage",
        "name": "About Earthbound Martian",
        "description": "Earthbound Martian builds rugged Landship camper van rentals for adventure, remote work, and off-grid exploration within 350 miles of DFW.",
        "url": "https://earthboundmartian.com/about"
      },
      {
        "@type": "Organization",
        "@id": "https://earthboundmartian.com/#organization",
        "name": "Earthbound Martian",
        "description": "Builders of exceptional Landships — rugged camper vans for rent that enable freedom to live and work on the road.",
        "url": "https://earthboundmartian.com",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Richardson",
          "addressRegion": "TX",
          "addressCountry": "US"
        },
        "founder": [
          {
            "@type": "Person",
            "name": "Chris"
          },
          {
            "@type": "Person",
            "name": "Cally"
          }
        ]
      }
    ]
  };

  return (
    <Layout structuredData={structuredData}>
      <div className="max-w-4xl mx-auto px-6 py-20">
        <h1 className="text-5xl font-bold text-alt-blk mb-8">
          About Earthbound Martian
        </h1>

        <div className="prose prose-xl text-zinc-600">
          <h2 className="text-3xl font-bold text-alt-blk mt-16 mb-6">
            Our Founders
          </h2>
          <p className="text-lg">
            Our founders are Chris and Cally — a pair of goofy polymaths from
            the suburbs of Texas who love building things almost as much as we
            love hitting the road and exploring.
          </p>

          <h2 className="text-3xl font-bold text-alt-blk mt-16 mb-6">
            How it started
          </h2>
          <p className="text-lg">
            We finally went on our honeymoon after 25 years of marriage. It was a mad dash from Richardson
            up to the Grand Tetons, back down to Carlsbad Caverns and over to Richardson. During the trip,
            we fell in love with the road and camping in new places.

            On the way back, we took stock of the trip and the rig we had rented and agreed, "we can do better!"

            We started with our old plumber's van and challenged ourselves to build it into an amazing camper van.
            We finished in mid 2025 and the rest is history!
          </p>

          <h2 className="text-3xl font-bold text-alt-blk mt-16 mb-6">
            Our Mission
          </h2>
          <p className="text-lg">
            Earthbound Martian exists to build exceptional Landships — mobile
            offices, workspaces, and cabins — that give businesses the freedom
            to meet customers where they are, and give people the freedom to
            live and work wherever life calls them.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default About;
